import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  TextField,
  Typography,
  IconButton,
  Button,
  makeStyles,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip
} from "@material-ui/core";
import {
  Search,
  Delete,
  Person,
  Build,
  ReportProblem,
  LocalMall,
  Add,
  Close,
} from "@material-ui/icons";
import axios from "src/utils/baseAxios";
import { getUser } from "src/utils/Common";
import {
  DataSheetGrid,
  textColumn,
  keyColumn,
} from "react-datasheet-grid";
import "react-datasheet-grid/dist/style.css";
import DeleteIcon from "@material-ui/icons/Delete";
import MuiAlert from "@material-ui/lab/Alert";
import Pagination from "@material-ui/lab/Pagination";
import { Fade } from "@material-ui/core";
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import CompensationDetail from "./CompensationDetail";
import { useTranslation } from "react-i18next";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    padding: theme.spacing(5),
    fontFamily: "'Poppins', 'Inter', sans-serif",
    [theme.breakpoints.down("sm")]: { padding: theme.spacing(2.5) },
  },
  title: {
    fontWeight: 800,
    fontSize: "2rem",
    color: "#1e1b4b",
    marginBottom: theme.spacing(4),
    textShadow: "0 2px 6px rgba(90,60,200,0.1)",
  },
  sectionCard: {
    background: "rgba(255,255,255,0.8)",
    borderRadius: 24,
    backdropFilter: "blur(10px)",
    boxShadow: "0 20px 40px rgba(60,60,120,0.15)",
    padding: theme.spacing(4),
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
    borderRadius: 14,
    backgroundColor: "#fff",
    transition: "all 0.2s ease-in-out",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#4DA3FF",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWidth: 2,
      borderColor: "#1B84FF",
      boxShadow: "0 0 6px rgba(27,132,255,0.3)",
    },
    },
    "& .MuiInputBase-input": {
      paddingTop: 14,
      paddingBottom: 14,
    },
  },
  buttonGroup: {
    display: "flex",
    gap: theme.spacing(2.5),
  },
  searchButton: {
    background: "linear-gradient(90deg, #739fd1d5, #4a86cad5)",
    color: "#fff",
    fontWeight: 600,
    padding: theme.spacing(1.2, 3),
    borderRadius: 12,
    textTransform: "none",
    boxShadow: "0 4px 14px rgba(99, 132, 241, 0.3)",
    "&:hover": {
      background: "linear-gradient(90deg, #6190c7d5, #336eb1d5)",
    },
    marginLeft: 5,
  },
  multiButton: {
    background: "linear-gradient(90deg, #739fd1d5, #4a86cad5)",
    color: "#fff",
    fontWeight: 600,
    padding: theme.spacing(1.2, 3),
    borderRadius: 12,
    textTransform: "none",
    boxShadow: "0 4px 14px rgba(99, 132, 241, 0.3)",
    "&:hover": {
      background: "linear-gradient(90deg, #6190c7d5, #336eb1d5)",
    },
    marginLeft: 5,
  },
  workOrderCard: {
    position: "relative",
    borderRadius: 20,
    overflow: "hidden",
    background: "linear-gradient(135deg, #dfeaf0ff 0%, #4a86cad5 100%)",
    boxShadow:
      "0 6px 20px rgba(99,102,241,0.1), 0 0 0 1px rgba(99,102,241,0.05)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": { transform: "translateY(-6px)" },
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2.5, 3),
    borderBottom: "2px solid #b5c9f1ff",
    background: "linear-gradient(135deg, #f4f6f7ff 0%, #d9eefedd 100%)",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  workOrderId: {
    background: "linear-gradient(90deg, #ffd3b4ff, #fe8843cc)",
    color: "#fff",
    fontSize: "1.0rem",
    padding: "4px 12px",
    borderRadius: 10,
    fontWeight: 500,
  },
  serviceShop: {
    fontSize: "0.8rem",
    fontWeight: 400,
    color: "#1e1b4b",
    marginLeft: 5,
  },
  detailBtn: {
    color: "#257d65ff", 
    backgroundColor: "rgba(27,94,32,0.1)",
    borderRadius: 10,
    padding: 6,
    marginLeft: 8,
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#13604dff",
      transform: "scale(1.05)",
    },
  },
  deleteBtn: {
    color: "#ba3c3cff",
    backgroundColor: "rgba(183,28,28,0.1)",
    borderRadius: 10,
    padding: 6,
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#932a2aff",
      transform: "scale(1.05)",
    },
    marginLeft: 8,
  },
  cardBody: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(5),
    padding: theme.spacing(3),
  },
  infoBox: {
    backgroundColor: "white",
    borderRadius: 14,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  infoTitle: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontWeight: 700,
    fontSize: "0.95rem",
    color: "#0079FF",
    marginBottom: 8,
  },
  icon: { color: "#153c68ff", fontSize: 20 },
  titleBar: {
    height: 3,
    width: "100%",
    background:
      "linear-gradient(90deg, #00B2FF 0%, #0079FF 60%, transparent 100%)",
    borderRadius: 2,
    marginTop: theme.spacing(1),
  },
  btn: {
    background: "linear-gradient(90deg, #739fd1d5, #4a86cad5)",
    color: "#fff",
    fontWeight: 400,
    padding: theme.spacing(1.2, 3),
    borderRadius: 12,
    textTransform: "none",
    boxShadow: "0 4px 14px rgba(99, 132, 241, 0.3)",
    "&:hover": {
      background: "linear-gradient(90deg, #6190c7d5, #336eb1d5)",
    },
  },
additionalFilterBtn: {
  height: 42,              
  padding: "0 16px",
  borderRadius: 12,
  fontSize: "13px",
  fontWeight: 600,
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  backgroundColor: "#ffffff",
  border: "1.5px solid #dce6f5",
  color: "#4b5c6b",
  cursor: "pointer",
  transition: "all 0.22s ease",
  marginLeft: 16,          
  boxShadow: "0 2px 5px rgba(0,0,0,0.04)",
  
  "&:hover": {
    backgroundColor: "#f2f7ff",
    borderColor: "#bcd4ff",
    boxShadow: "0 3px 8px rgba(145,180,255,0.25)",
  },
},

additionalFilterBtnActive: {
  backgroundColor: "#76a9ff !important",
  borderColor: "#76a9ff !important",
  color: "#fff !important",
  boxShadow: "0 3px 10px rgba(118,169,255,0.45) !important",
},
}));

export default function CreateCompensationRequest() {
  const classes = useStyles();
  const SessionUser = getUser();
  const { t } = useTranslation('overview');

  const [workOrderId, setWorkOrderId] = useState("");
  const [loading, setLoading] = useState(false);
  const [workOrders, setWorkOrders] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [gridData, setGridData] = useState([{ WorkOrderId: "" }]);
  const [selection, setSelection] = useState({ start: {}, end: {} });

  const [singleResult, setSingleResult] = useState(null);
  const [multiSummary, setMultiSummary] = useState(null);
  const [multiDetails, setMultiDetails] = useState([]);

  const [filterText, setFilterText] = useState("");
  const [confirm, setConfirm] = useState({ open: false, item: null });

  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [showAdditionalNeedOnly, setShowAdditionalNeedOnly] = useState(false);

  // Pagination states
  const [page, setPage] = useState(1);
  const itemsPerPage = 8;

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" }); 
  };

  const filteredWorkOrders = workOrders
  // 🔍 WorkOrderId filter
  .filter((wo) =>
    wo.WorkOrderId?.toString().toLowerCase().includes(filterText.toLowerCase())
  )
  // 🔧 Additional Need filter
  .filter((wo) =>
    showAdditionalNeedOnly
      ? wo.MobileStatusId === 73 || wo.MobileStatusId === 74 //eu - russia difference
      : true
  );

  const paginatedWorkOrders = filteredWorkOrders.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  useEffect(() => {
    fetchCompensationList();

    const onFocus = () => fetchCompensationList();
    window.addEventListener("focus", onFocus);

    return () => window.removeEventListener("focus", onFocus);
  }, []);

  const fetchCompensationList = async () => {
    try {
      const res = await axios.get("/tradepartner/compensation-get-workorders", {
        params: { serviceShopId: SessionUser.ServiceShopId },
      });
      setWorkOrders(res.data?.Data || []);
    } catch (err) {
      console.error(err);
    }
  };

   const handleSearchGeneric = async (ids, isMulti = false) => {
    if (!ids || ids.length === 0) {
      if (isMulti)
        setMultiSummary(`⚠️ ${t("pleaseEnterAtLeastOneWorkOrderId")}`);
      else
        setSingleResult({ type: "warning", text: t("pleaseEnterWorkOrderId") });
      return;
    }

    setLoading(true);
    if (isMulti) {
      setMultiSummary(null);
      setMultiDetails([]);
    } else {
      setSingleResult(null);
    }

    try {
      const res = await axios.post("/tradepartner/compensation-check-workorder", {
        WorkOrderIds: JSON.stringify(ids),
        ServiceShopId: SessionUser.ServiceShopId,
        TenantId: SessionUser.TenantId,
      });

      const response = res.data?.Data || res.data || [];

      if (!Array.isArray(response) || response.length === 0) {
        if (isMulti)
          setMultiSummary(`⚠️ ${t("unexpectedError")}`);
        else
          setSingleResult({ type: "error", text: t("unexpectedError") });
        return;
      }

      // 🔸 Single Search
      if (!isMulti) {
        const { WorkOrderId, Status } = response[0];

        const msg =
          Status === "NOT_FOUND"
            ? { type: "error", text: `#${WorkOrderId} ${t("notFound")}.` }
            : Status === "EXISTS"
            ? { type: "warning", text: `#${WorkOrderId} ${t("alreadyExists")}.` }
            : Status === "REACTIVATED"
            ? { type: "info", text: `#${WorkOrderId} ${t("reactivated")}.` }
            : Status === "OTHER_SERVICE"
            ? { type: "error", text: `#${WorkOrderId} ${t("inAnotherService")}.` }
            : { type: "success", text: `#${WorkOrderId} ${t("successfullyAdded")}.` };

        setSingleResult(msg);
      }

      // 🔸 Multi Search
      if (isMulti) {
        const inserted = response.filter((x) => x.Status === "INSERTED");
        const exists = response.filter((x) => x.Status === "EXISTS");
        const reactivated = response.filter((x) => x.Status === "REACTIVATED");
        const notFound = response.filter((x) => x.Status === "NOT_FOUND");
        const otherService = response.filter((x) => x.Status === "OTHER_SERVICE");

        setMultiSummary(
          `${inserted.length} ${t("added")} | ` +
          `${reactivated.length} ${t("reactivated")} | ` +
          `${exists.length} ${t("alreadyExists")} | ` +
          `${otherService.length} ${t("inAnotherService")} | ` +
          `${notFound.length} ${t("notFound")}`
        );
        setMultiDetails([...notFound, ...otherService]);
      }
      await fetchCompensationList();
    } catch (err) {
      console.error(err);
      if (isMulti) setMultiSummary(`❌ ${t("serverError")}`);
      else setSingleResult({ type: "error", text: `❌ ${t("serverError")}` });
    } finally {
      setLoading(false);
    }
  };

  const handleSingleSearch = () => {
    if (!workOrderId.trim()) return;
    handleSearchGeneric([workOrderId]);
  };

  const handleMultiSearch = () => {
    const ids = gridData
      .map((r) => r.WorkOrderId?.trim())
      .filter((x) => x && x !== "");
    handleSearchGeneric(ids, true);
  };

  const askDelete = (wo) => {
    setConfirm({ open: true, item: wo });
  };

  const confirmDelete = async () => {
    if (!confirm.item) return;

    try {
      setLoading(true);

      const res = await axios.post(
        `/tradepartner/compensation-set-active?id=${confirm.item.Id}&flag=false`
      );

      if (res.data?.Success) {
        setSingleResult({
          type: "success",
          text: `#${confirm.item.WorkOrderId} ${t("deletedSuccessfully")}`,
        });
        await fetchCompensationList();
      } else {
        setSingleResult({
          type: "error",
          text: `#${confirm.item.WorkOrderId} ${t("couldNotBeDeleted")}: ${res.data?.message || t("error")}`,
        });
      }
    } catch (err) {
      console.error(err);
      setSingleResult({
        type: "error",
        text: t("serverError", "Server error! Please try again."),
      });
    } finally {
      setLoading(false);
      setConfirm({ open: false, item: null });
    }
  };

const closeConfirm = () => setConfirm({ open: false, item: null });


  return (
    <Box className={classes.root}>
      {!selectedWorkOrder ? (
        <Card className={classes.sectionCard}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography className={classes.title}>
                {t("createCompensationRequest", "Create Compensation Request")}
              </Typography>
              <div className={classes.titleBar} />
            </Grid>

            {/* 🔹 Tekli Search */}
            <Grid item xs={12} md={8}>
              <TextField
                label={t("workOrderIdLabel", "Work Order ID")}
                variant="outlined"
                fullWidth
                value={workOrderId}
                onChange={(e) => setWorkOrderId(e.target.value)}
                className={classes.searchField}
              />
            </Grid>

            <Grid item xs={12} md={4} className={classes.buttonGroup}>
              <Button
                className={classes.searchButton}
                onClick={handleSingleSearch}
                disabled={loading}
                startIcon={<Search />}
                fullWidth
              >
                {loading ? <CircularProgress size={20} color="inherit" /> : t("search", "Search")}
              </Button>
              <Button
                className={classes.multiButton}
                startIcon={<Add />}
                onClick={() => setOpenDialog(true)}
                fullWidth
              >
                {t("multiSearch", "Multi Search")}
              </Button>
            </Grid>

            {/* 🔸 Single Alert */}
            {singleResult && (
              <Grid item xs={12}>
                <Fade in={!!singleResult}>
                  <Alert
                    severity={singleResult.type}
                    onClose={() => setSingleResult(null)}
                    style={{
                      marginTop: 4,
                      borderRadius: 12,
                      fontSize: "0.9rem",
                      alignItems: "center",
                    }}
                  >
                    {singleResult.text}
                  </Alert>
                </Fade>
              </Grid>
            )}

            {/* 🔹 Filter Bar */}
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" justifyContent="flex-start" mb={2}>
                <TextField
                  label={t("filterByWorkOrderId", "Filter by WorkOrderId")}
                  variant="outlined"
                  size="small"
                  className={classes.searchField}
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  style={{ width: 250 }}
                  InputProps={{
                    style: { borderRadius: 12, backgroundColor: "#fff" },
                  }}
                />
                {/* 🔹 Additional Need Filter Button */}
                <Tooltip title="Work orders with missing or insufficient information" arrow>
                <Button
                  onClick={() => setShowAdditionalNeedOnly(!showAdditionalNeedOnly)}
                  className={
                    showAdditionalNeedOnly
                      ? `${classes.additionalFilterBtn} ${classes.additionalFilterBtnActive}`
                      : classes.additionalFilterBtn
                  }
                >
                  <span style={{ fontSize: 16 }}>🧩</span>
                  Additional Need
                </Button>
                </Tooltip>
              </Box>
            </Grid>

            {/* 🔹 WorkOrders List */}
            <Grid item xs={12}>
              <Grid container spacing={3}>
                {filteredWorkOrders.length === 0 ? (
                  <Grid item xs={12}>
                    <Typography align="center" color="textSecondary">
                      {workOrders.length === 0
                        ? t("noRecordsFoundYet", "No records found yet.")
                        : t("noResultsMatching", "No results were found matching your search criteria.")}
                    </Typography>
                  </Grid>
                ) : (
                  paginatedWorkOrders.map((wo) => (
                    <Grid item xs={12} sm={6} md={3} key={wo.WorkOrderId}>
                      <Card className={classes.workOrderCard}>
                        <Box className={classes.cardHeader}>
                          <Box className={classes.headerLeft}>
                            <Typography className={classes.workOrderId}>
                              #{wo.WorkOrderId}
                            </Typography>
                          </Box>
                          <Box display="flex" alignItems="center">
                            <IconButton
                              size="small"
                              className={classes.deleteBtn}
                              onClick={() => askDelete(wo)}
                            >
                              <Delete />
                            </IconButton>
                            <IconButton
                              size="small"
                              className={classes.detailBtn}
                              onClick={() => setSelectedWorkOrder(wo)}
                            >
                              <ArrowRightAltIcon />
                            </IconButton>
                          </Box>
                        </Box>

                        <Box className={classes.cardBody}>
                          {/* 👤 Customer */}
                          <Box className={classes.infoBox}>
                            <Typography className={classes.infoTitle}>
                              <Person className={classes.icon} /> {t("customer", "Customer")}
                            </Typography>
                            <Typography>{t("nameLabel", "Name")}: {wo.FirstName}</Typography>
                            <Typography>{t("surnameLabel", "Surname")}: {wo.LastName}</Typography>
                            <Typography>{t("phoneLabel", "Phone")}: {wo.FullPhone}</Typography>
                          </Box>

                          {/* 🛒 Product */}
                          <Box className={classes.infoBox}>
                            <Typography className={classes.infoTitle}>
                              <LocalMall className={classes.icon} /> {t("product", "Product")}
                            </Typography>
                            <Typography>{t("skuLabel", "SKU")}: {wo.SKU}</Typography>
                            <Typography>{t("modelLabel", "Model")}: {wo.MarketingCode}</Typography>
                          </Box>

                          {/* ⚠️ Issue */}
                          <Box className={classes.infoBox}>
                            <Typography className={classes.infoTitle}>
                              <ReportProblem className={classes.icon} /> {t("issue", "Issue")}
                            </Typography>
                            <Typography>{wo.IssueDescription || "—"}</Typography>
                          </Box>

                          {/* 🔧 Technician Comment */}
                          <Box className={classes.infoBox}>
                            <Typography className={classes.infoTitle}>
                              <Build className={classes.icon} /> {t("technicianComment", "Technician Comment")}
                            </Typography>
                            <Typography>{wo.TechComment || "—"}</Typography>
                          </Box>
                        </Box>
                      </Card>
                    </Grid>
                  ))
                )}
              </Grid>

              {/* 🔸 Pagination Bar */}
              {filteredWorkOrders.length > itemsPerPage && (
                <Box display="flex" justifyContent="center" mt={4}>
                  <Pagination
                    count={Math.ceil(filteredWorkOrders.length / itemsPerPage)}
                    page={page}
                    onChange={handlePageChange}
                    color="primary"
                    shape="rounded"
                    size="medium"
                  />
                </Box>
              )}
            </Grid>
          </Grid>
        </Card>
      ) : (
        <CompensationDetail
          workOrder={selectedWorkOrder}
          onBack={() => {
            setSelectedWorkOrder(null);
            setWorkOrderId(null);
            fetchCompensationList();
          }}
        />
      )}


      {/* MULTI SEARCH DIALOG */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ style: { minHeight: "600px" } }}
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            {t("multipleWorkOrderSearch", "Multiple WorkOrder Search")}
            <IconButton onClick={() => setOpenDialog(false)}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {t("multiSearchHint", "You can copy and paste or type directly. Each line represents a WorkOrderId.")}
          </Typography>
          <DataSheetGrid
            columns={[
              {
                ...keyColumn("WorkOrderId", textColumn),
                title: "WorkOrderId",
                grow: 1,
              },
              {
                key: "delete",
                title: "",
                grow: 0,
                basis: 48,
                component: ({ rowIndex }) => (
                  <IconButton
                    size="small"
                    onClick={() =>
                      setGridData((prev) =>
                        prev.filter((_, i) => i !== rowIndex)
                      )
                    }
                    tabIndex={-1}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                ),
              },
            ]}
            value={gridData}
            onChange={setGridData}
            onSelectionChange={setSelection}
            minRows={1}
            height={400}
            disableExpandSelection
            sheetProps={{
              tabIndex: 0,
              style: { padding: 12 },
            }}
          />

          {multiSummary && (
            <Box mt={3}>
              <Alert
                severity="info"
                onClose={() => {
                  setMultiSummary(null);
                  setMultiDetails([]);
                }}
                style={{
                  borderRadius: 12,
                  fontSize: "0.9rem",
                }}
              >
                <strong>{multiSummary}</strong>
              </Alert>

            {/* 🔴 Bulunamayan WorkOrderId’ler listesi */}
            {multiDetails.length > 0 && (
              <Box mt={1} pl={1}>
                {multiDetails.map((x, i) => (
                  <Typography key={i} variant="body2" color="error">
                    #{x.WorkOrderId} ➜ {x.Status}
                  </Typography>
                ))}
            </Box>
            ) }
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button className={classes.btn} onClick={() => setGridData([{ WorkOrderId: "" }])}>
            {t("clear", "Clear")}
          </Button>
          <Button
            className={classes.btn}
            variant="contained"
            onClick={handleMultiSearch}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              t("searchAll", "Search All")
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirm.open}
        onClose={closeConfirm}
        fullWidth
        maxWidth="xs"
        aria-labelledby="confirm-passive-title"
      >
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary">
          {t("confirmDeleteQuestion", "Are you sure you want to delete it?")}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={closeConfirm} disabled={loading}>
          {t("cancel", "Cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={confirmDelete}
          disabled={loading}
          style={{ backgroundColor: "#d32f2f", color: "#fff" }}
          startIcon={!loading ? <Delete /> : null}
        >
          {loading ? <CircularProgress size={18} color="inherit" /> : t("ok", "Ok")}
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
}
